import React from "react";
import pageloader from "../assets/images/ai.gif";
export default function PageLoader() {
  return (
    <>
      <div className="page-loader" style={{ display: "block" }}>
        <div className="inner-loader">
          <img src={pageloader} style={{ width: "100px" }} />
          <span>Loading... Won't be a minute</span>
        </div>
      </div>
    </>
  );
}
